import Navbar from './sections/homepage/navbar/Navbar';
import Header from './sections/homepage/header/Header';
import About from './sections/homepage/about/About';
import Services from './sections/homepage/services/Services';
import Portfolio from './sections/homepage/portfolio/Portfolio';
//import Testimonials from './sections/homepage/testimonials/Testimonials';
//import FAQs from './sections/homepage/faqs/FAQs';
import Contact from './sections/homepage/contact/Contact';
import Footer from './sections/homepage/footer/Footer';
import FloatingNav from './sections/homepage/floating-nav/FloatingNav';
import Theme from './theme/Theme';
import { useThemeContext } from './context/theme-context';
import { useRef, useState, useEffect, useCallback } from 'react'
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import InternshipDetailPage from './sections/internship/InternshipDetailPage';
// import InternshipDetailPageDummy from './sections/internship/InternshipDetailPageDummy';
import ParticipantsTestimonials from "./sections/internship/testimonials-internship/ParticipantTestimonials";
import Admin from './sections/admin/Admin';
import AdminGeneralContacts from './sections/admin/AdminGeneralContacts';
import AdminInternshipContacts from './sections/admin/AdminInternshipContacts';
import Login from './sections/login/Login';
import ProtectedRoute from './components/ProtectedRoute';
import BlogList from './sections/blog/BlogList';
import BlogDetail from './sections/blog/BlogDetail';
import AdminBlogs from './sections/admin/AdminBlogs';
import AdminBlogEdit from './sections/admin/AdminBlogEdit';
import AdminCourses from './sections/admin/AdminCourses';
import AdminCourseEdit from './sections/admin/AdminCourseEdit';
import AdminReviews from './sections/admin/AdminReviews';
import AdminVideos from './sections/admin/AdminVideos';
import CookieConsent from './components/CookieConsent';

// Create a separate component that uses React Router hooks
const AppContent = () => {
  const { themeState } = useThemeContext();
  const location = useLocation();

  const mainRef = useRef();
  const [showFloatingNav, setShowFloatingNav] = useState(true);
  const [siteYPostion, setSiteYPosition] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [isPageTransitioning, setIsPageTransitioning] = useState(false);

  // Determine if we're on internship page
  const isInternshipPage = location.pathname.startsWith('/virtual-internship/');

  const showFloatingNavHandler = () => {
    setShowFloatingNav(true);
  }

  const hideFloatingNavHandler = () => {
    setShowFloatingNav(false);
  }

  const floatingNavToggleHandler = useCallback(() => {
    if (siteYPostion < (mainRef?.current?.getBoundingClientRect().y - 20) ||
      siteYPostion > (mainRef?.current?.getBoundingClientRect().y + 20)) {
      showFloatingNavHandler();
    } else {
      hideFloatingNavHandler();
    }
    setSiteYPosition(mainRef?.current?.getBoundingClientRect().y);
  }, [siteYPostion]);

  useEffect(() => {
    const checkYPosition = setInterval(floatingNavToggleHandler, 2000);

    // cleanup function
    return () => clearInterval(checkYPosition);
  }, [siteYPostion, floatingNavToggleHandler]);

  // Handle page transitions and scrolling
  useEffect(() => {
    // Show transition loading when navigating to internship pages
    if (isInternshipPage) {
      setIsPageTransitioning(true);
      const timer = setTimeout(() => {
        setIsPageTransitioning(false);
      }, 100); // Small delay to ensure smooth transition
      return () => clearTimeout(timer);
    }

    // Handle scrolling for home page
    if (location.pathname === '/') {
      const hash = location.hash;
      if (hash) {
        const elementId = hash.substring(1);
        setTimeout(() => {
          const element = document.getElementById(elementId);
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }, 100);
      } else {
        window.scrollTo({ top: 0, behavior: 'instant' });
      }
    } else {
      // For internship pages, instant scroll to top
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [location, isInternshipPage]);

  return (
    <main className={`${themeState.primary} ${themeState.background}`} ref={mainRef}>
      <Navbar />
      <Routes>
        {/* HOME PAGE ROUTE */}
        <Route path="/" element={
          <>
            <Header />
            <Services />
            <About />
            <Portfolio />
            <ParticipantsTestimonials />
            {/* <FAQs1 /> */}
            <Contact />
          </>
        } />

        {/* INTERNSHIP PAGE ROUTE */}
        <Route path="/virtual-internship/:courseType" element={<InternshipDetailPage />} />
        {/* <Route path="/dummy-internship/:courseType" element={<InternshipDetailPageDummy />} /> */}
        {/* LOGIN ROUTE */}
        <Route path="/login" element={<Login />} />
        {/* ADMIN DASHBOARD */}
        <Route path="/admin" element={
          <ProtectedRoute>
            <Admin />
          </ProtectedRoute>
        } />
        <Route path="/admin/general" element={
          <ProtectedRoute>
            <AdminGeneralContacts />
          </ProtectedRoute>
        } />
        <Route path="/admin/internship" element={
          <ProtectedRoute>
            <AdminInternshipContacts />
          </ProtectedRoute>
        } />

        {/* PUBLIC BLOG ROUTES */}
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:id" element={<BlogDetail />} />

        {/* ADMIN BLOG ROUTES */}
        <Route path="/admin/blogs" element={
          <ProtectedRoute>
            <AdminBlogs />
          </ProtectedRoute>
        } />
        <Route path="/admin/blogs/new" element={
          <ProtectedRoute>
            <AdminBlogEdit />
          </ProtectedRoute>
        } />
        <Route path="/admin/blogs/edit/:id" element={
          <ProtectedRoute>
            <AdminBlogEdit />
          </ProtectedRoute>
        } />

        {/* ADMIN COURSE ROUTES */}
        <Route path="/admin/courses" element={
          <ProtectedRoute>
            <AdminCourses />
          </ProtectedRoute>
        } />
        <Route path="/admin/courses/new" element={
          <ProtectedRoute>
            <AdminCourseEdit />
          </ProtectedRoute>
        } />
        <Route path="/admin/courses/edit/:id" element={
          <ProtectedRoute>
            <AdminCourseEdit />
          </ProtectedRoute>
        } />

        {/* ADMIN REVIEWS ROUTES */}
        <Route path="/admin/reviews" element={
          <ProtectedRoute>
            <AdminReviews />
          </ProtectedRoute>
        } />

        {/* ADMIN VIDEO TESTIMONIALS ROUTES */}
        <Route path="/admin/videos" element={
          <ProtectedRoute>
            <AdminVideos />
          </ProtectedRoute>
        } />
      </Routes>

      <Footer />
      <Theme />
      {showFloatingNav && <FloatingNav />}
      <CookieConsent />
    </main>
  )
}

// Main App component
const App = () => {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  )
}

export default App